// components/Shared/Pagination.jsx
import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pagesToShow = 3;
  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  return (
    <div className="flex justify-center mb-8 transform-gpu transition-medium hover:scale-[1.01]">
      <div className="flex items-center space-x-1">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-10 h-10 rounded-lg flex items-center justify-center bg-dark-500 hover:bg-dark-400 transition transform-gpu hover:-translate-y-0.5 disabled:opacity-50 disabled:hover:translate-y-0"
        >
          <i className="fas fa-chevron-left text-sm"></i>
        </button>
        
        {startPage > 1 && (
          <span className="px-2 text-gray-400 hover:text-white transition-medium">...</span>
        )}
        
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-10 h-10 rounded-lg flex items-center justify-center transition transform-gpu hover:-translate-y-0.5 ${
              page === currentPage 
                ? 'bg-accent-purple text-white hover:shadow-glow' 
                : 'bg-dark-500 hover:bg-dark-400'
            }`}
          >
            {page}
          </button>
        ))}
        
        {endPage < totalPages && (
          <span className="px-2 text-gray-400 hover:text-white transition-medium">...</span>
        )}
        
        {totalPages > pagesToShow && (
          <button
            onClick={() => onPageChange(totalPages)}
            className={`w-10 h-10 rounded-lg flex items-center justify-center transition transform-gpu hover:-translate-y-0.5 ${
              totalPages === currentPage 
                ? 'bg-accent-purple text-white hover:shadow-glow' 
                : 'bg-dark-500 hover:bg-dark-400'
            }`}
          >
            {totalPages}
          </button>
        )}
        
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-10 h-10 rounded-lg flex items-center justify-center bg-dark-500 hover:bg-dark-400 transition transform-gpu hover:-translate-y-0.5 disabled:opacity-50 disabled:hover:translate-y-0"
        >
          <i className="fas fa-chevron-right text-sm"></i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;